import type { ApiClient } from './client.js';
import type { PreferencesDto, MmPagesEnabledDto, SearchEngineDto } from './types.js';

export interface UpdatePreferencesBody {
  themeKey?: string;
  searchEngine?: SearchEngineDto;
  showYesterdayTomorrow?: boolean;
  mmPagesEnabled?: MmPagesEnabledDto;
}

export interface PreferencesApi {
  get(): Promise<PreferencesDto>;
  update(patch: UpdatePreferencesBody): Promise<PreferencesDto>;
}

export function createPreferencesApi(client: ApiClient): PreferencesApi {
  return {
    async get() {
      const res = await client.get<{ preferences: PreferencesDto }>('/api/preferences');
      return res.preferences;
    },
    async update(patch) {
      const res = await client.put<{ preferences: PreferencesDto }>('/api/preferences', patch);
      return res.preferences;
    },
  };
}
